import React from "react";

const NotFoundError = () => {
  return (
    <div className='h-screen flex flex-col items-center justify-center' >
      <p className="text-4xl font-bold" >404</p>
      <p>Not Found</p>
    </div>
  );
};

export default NotFoundError;
